import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel'

// Docs and demos: https://owlcarousel2.github.io/OwlCarousel2/demos/demos.html

$(function () {
    // Sample Carousel
    $('.owl-carousel.owl-sample-carousel').owlCarousel({
        loop: false,
        margin: 10,
        nav: false,
        dots: false,
        single: true,
        items: 1,
        center: true,
        URLhashListener: true
    });

    $('.owl-carousel.owl-brands-carousel').owlCarousel({
        loop: false,
        margin: 30,
        nav: false,
        dots: false,
        responsive: {
            0: {
                items: 2
            },
            576: {
                items: 3
            },
            768: {
                items: 4
            },
            992: {
                items: 6
            }
        }
    });


    $('.owl-carousel.owl-detail-product').owlCarousel({
        loop: false,
        margin: 10,
        nav: true,
        dots: false,
        single: true,
        items: 1,
        center: true,
        URLhashListener: true
    });


    $('.owl-carousel.owl-detail-product-dots').owlCarousel({
        loop: false,
        margin: 10,
        nav: false,
        autoWidth: true,
        dots: false,
    });



    $('.owl-carousel.owl-main-hero-carousel').owlCarousel({
        loop: false,
        margin: 10,
        nav: true,
        dots: true,
        single: true,
        items: 1,
        center: true,
        URLhashListener: true,
        autoplay: true
    });

    $('.owl-carousel.owl-carousel-sponzors').owlCarousel({
        loop: true,
        margin: 30,
        nav: true,
        dots: false,
        responsive: {
            0: {
                items: 1
            },
            576: {
                items: 2
            },
            768: {
                items: 3
            },
            992: {
                items: 5
            },
            1200: {
                items: 7
            }
        }
    });

    $('.owl-carousel.owl-blog-carousel').owlCarousel({
        loop: false,
        margin: 16,
        nav: false,
        dots: false,
        responsive: {
            0: {
                items: 1
            },
            576: {
                items: 2
            },
            768: {
                items: 3
            },
            992: {
                items: 4
            },
            1200: {
                items: 4
            },
            1700: {
                items: 5,
            }
        }
    });

    $('.owl-carousel.owl-carousel-price-list').owlCarousel({
        loop: false,
        margin: 10,
        nav: false,
        dots: false,
        autoWidth: true,
        responsive: {
            0: {
                items: 1
            },
            576: {
                items: 1
            },
            768: {
                items: 2
            },
            992: {
                items: 3
            },
            1200: {
                items: 4
            }
        }
    });


    $('.owl-carousel.owl-products-carousel').owlCarousel({
        loop: false,
        margin: 16,
        nav: false,
        dots: false,
        responsive: {
            0: {
                items: 2
            },
            390: {
                items: 2
            },
            768: {
                items: 3
            },
            1200: {
                items: 4
            },
            1600: {
                items: 5
            }
        }
    });

    $('.owl-carousel.owl-carousel-barbers').owlCarousel({
        loop: false,
        margin: 10,
        nav: false,
        dots: false,
        responsive: {
            0: {
                items: 1
            },
            576: {
                items: 2
            },
            768: {
                items: 2
            },
            992: {
                items: 5
            }
        }
    });

    $('.owl-carousel.owl-category-carousel').owlCarousel({
        loop: false,
        margin: 10,
        nav: false,
        dots: false,
        responsive: {
            0: {
                items: 2
            },
            360: {
                items: 2
            },
            768: {
                items: 3
            },
            992: {
                items: 5
            }
        }
    });


    $(".owl-carousel-container .carousel-control-prev-icon").on('click', function () {
        $(this).parents(".owl-carousel-container").find($('.owl-carousel')).trigger('prev.owl.carousel');
    });

    $(".owl-carousel-container .carousel-control-next-icon").on('click', function () {
        $(this).parents(".owl-carousel-container").find($('.owl-carousel')).trigger('next.owl.carousel');
    });
});
